<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="whatsapp_cloud">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD') }}
          </option>
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO') }}
          </option>
          <option value="gupshup">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.GUPSHUP') }}
          </option>
        </select>
      </label>
    </div>

    <twilio v-if="provider === 'twilio'" type="whatsapp" />
    <three-sixty-dialog-whatsapp v-else-if="provider === '360dialog'" />
    <gupshup-whatsapp v-else-if="provider === 'gupshup'" />
    <template v-else>
      <!-- Siempre mostramos el flujo Embedded Signup si está disponible -->
      <template v-if="!showManualSetup">
        <whatsapp-embedded-signup />
        <p class="mt-4 text-sm text-slate-600 dark:text-slate-300">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_SETUP_LINK_TEXT') }}
          <button
            type="button"
            class="text-primary-600 dark:text-primary-400 underline hover:text-primary-700 dark:hover:text-primary-300"
            @click="showManualSetup = true"
          >
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_SETUP_LINK') }}
          </button>
        </p>
      </template>
      <!-- Formulario manual cuando el usuario lo solicita -->
      <template v-else>
        <div class="mb-4">
          <button
            type="button"
            class="text-sm text-primary-600 dark:text-primary-400 underline hover:text-primary-700 dark:hover:text-primary-300"
            @click="showManualSetup = false"
          >
            ← {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.BACK_TO_AUTOMATIC_SETUP') }}
          </button>
        </div>
        <cloud-whatsapp />
      </template>
    </template>
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import Twilio from './Twilio.vue';
import ThreeSixtyDialogWhatsapp from './360DialogWhatsapp.vue';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';
import GupshupWhatsapp from './GupshupWhatsapp.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    ThreeSixtyDialogWhatsapp,
    CloudWhatsapp,
    WhatsappEmbeddedSignup,
    GupshupWhatsapp,
  },
  data() {
    return {
      provider: 'whatsapp_cloud',
      showManualSetup: false,
    };
  },
  computed: {
    hasWhatsappEmbeddedConfig() {
      const config = window.chatwootConfig || {};
      return Boolean(
        config.whatsappAppId &&
          config.whatsappConfigurationId &&
          config.whatsappApiVersion
      );
    },
  },
};
</script>
